import { t } from '@lingui/core/macro';
import { DialogHeader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FormDialog } from 'shared/domains/forms';
import { Content } from '../Content';
import { Footer } from '../Footer';
export function LikeDialog(props) {
    const { commentId, onClose, onLike, mutationError } = props;
    const initialValues = {
        id: commentId,
        feedback: '',
    };
    return (<FormDialog size="sm" onClose={onClose} onSubmit={onLike} initialValues={initialValues}>
      <DialogHeader icon={<Falcon icon="thumbs-up"/>} title={t({
            message: 'Provide feedback',
            comment: 'Document assistant - feedback dialog - title',
        })} subtitle={t({
            message: 'Let us know how we can improve',
            comment: 'Document assistant - feedback dialog - subtitle',
        })}/>
      <Content error={mutationError}/>
      <Footer onClose={onClose}/>
    </FormDialog>);
}
